<template>
	<div :class="'in-depth-item-container '+(visible ? 'visible' : '')" :key="sectionId" :data-section-id="sectionId">
		<!-- <base-icon v-if="isMobile" name="e-remove-3" class="exit-in-depth pointer" @click="exitModal" /> -->
		<base-button-rounded icon="e-remove-3" :color="backHover ? 'var(--color-dark-gold)' : 'var(--color-gold)'" icon-color="var(--color-black)" class="exit-in-depth" @button-clicked="exitModal" @mouseenter="() => backHover = true" @mouseleave="() => backHover = false"/>
		<div class="in-depth-item stack-vertical">
			<div class="font-caption-maiusc" style="align-self: center">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
			<div class="stack-horizontal in-depth-title" data-justify="spaced" data-align="center">
				<base-icon name="left-parenthesis"/>
				<div class="stack-vertical" data-align="center">
					<h3 class="in-depth-title-content capitalize-first" v-html="utils.markdownToHtml(title)"></h3>
					<p class="font-subhead in-depth-subtitle-content">{{subtitle}}</p>
				</div>
				<base-icon name="right-parenthesis"/>
			</div>
			<div v-for="content in contents" class="in-depth-item-contents">
				<div v-if="content.type == 'text'" class="in-depth-text-content" v-html="utils.markdownToHtml(content.content[$i18n.locale])"></div>
				<img v-else-if="content.type == 'image'" class="in-depth-image-content" :style="content.extraStyle" :src="imageUrl(content.content)">
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">

import utils from '@js/utils.js';
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash.clonedeep';
import { nextTick } from 'vue';

export default {
	name: 'InterfaceInDepth',
	props: {
		sectionId: {
			type: String
		},
		title: {
			type: String
		},
		subtitle: {
			type: String
		},
		contents: {
			type: Object
		},
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			converter: null,
			utils: utils,
			backHover: false,
			utils
		}
	},
	computed: {
		...mapGetters(['isMobile'])
	},
	watch: {
		visible(n, o) {
			if(n && !o) {
				document.querySelector(`.in-depth-item-container`).style.zIndex = 5
				document.querySelector('body').style.overflow = 'hidden'
				// console.log('set body overflow hidden')
			}else {
				// document.querySelector(`.in-depth-item-container`).style.zIndex = -1
				document.querySelector('body').style.overflow = 'unset'
				// console.log('set body overflow unset')
			}
		},
		async contents(n) {
			await nextTick();
			if(document.querySelector(`.in-depth-text-content a`)) {
				Array.from(document.querySelectorAll('.in-depth-text-content a')).forEach(el => {
					el.setAttribute('target', '_blank')
					el.style.textDecoration = 'underline'
				})
			}
		}
	},
	methods: {
		exitModal() {
			this.$emit('close-in-depth')
		},
		async manageAnimation() {
			let res = await utils.isElLoaded(`.in-depth-item-container`)
			let myEl = document.querySelector(`.in-depth-item-container`)
			myEl.style.zIndex = -1
			myEl.ontransitionend = e => {
				if(!this.visible && e.propertyName == 'opacity') {
					myEl.style.zIndex = -1;
				}
			}
			document.querySelector(`.in-depth-item-container .in-depth-item`).addEventListener('click', utils.stopPropagation, {passive: false})
		},
		async manageInDepthScroll() {
			// console.log('res', `#${this.sectionId} .in-depth-item-container`, this.$el.querySelector(`#${this.sectionId} .in-depth-item-container`))
			// this.$el.querySelector(`#${this.sectionId} .in-depth-item-container`).addEventListener('wheel', () => {
			// 	utils.stopPropagation();
			// }, {passive: false})
		},
		imageUrl(content) {
			return content;
		},
	},
	mounted() {
		(async () => {
			// await this.manageAnimation();
			await this.manageInDepthScroll();
		})()
	},
}

</script>

<style lang="scss">

	@import '@css/variables.scss';

	.in-depth-item-container {
		position: absolute;
		width: calc(100vw - var(--menu-size));
		height: 100%;
		left: var(--menu-size);
		top: 0;
		transition-property: opacity;
		transition-duration: .5s;
		background-color: var(--color-extra-light-gold);
		opacity: 0;
		display: flex;
		justify-content: center;
		overflow-y: scroll;
		pointer-events: none;
/*		z-index: -1;*/
	}

	.in-depth-item-container.visible {
		opacity: 1;
		z-index: 5;
		pointer-events: all;
	}

	.in-depth-item-container .in-depth-item  {
		z-index: 1;
		height: fit-content;
		width: 43.75rem;
		// padding: 4.5rem 0;
		gap: 5.5rem;
		margin: 5.7rem 0 6rem 0;
		transition-property: transform;
		transition-duration: .5s;
		overflow: hidden;
	}

	.in-depth-title-content {
		font-size: 2.125rem;
	}

	.in-depth-item-container.visible .in-depth-item {
		transform: translate(0, 0);
	}

	.in-depth-text-content {
		line-height: 2.2rem;
		display: flex;
		flex-direction: column;
		gap: 2.2rem;

		strong {
			font-weight: var(--font-medium);
		}
	}

	.in-depth-title .svg-icon {
		height: 7rem;
		--svg-icon-color: var(--color-gold);
	}

	.in-depth-title .svg-icon svg {
		height: 100%;
	}

	.in-depth-title h3 {
		text-align: center;
	}

	.exit-in-depth {
		position: fixed;
		right: 4.5rem;
		top: 4.5rem;
		z-index: 6;
	}

	.exit-in-depth .svg-icon {
		width: 1.375rem;
		height: 1.375rem;
	}

	.in-depth-image-content {
		max-width: 85%;
		filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.3));
	}

	.in-depth-subtitle-content {
		text-align: center;
	}

	@media (max-width: $breakpoint-sm) {
		.in-depth-item-container {
			position: fixed;
			overflow-y: scroll;
			width: 100vw;
			height: calc(100vh - var(--menu-size));
			top: var(--menu-size);
			left: 0;
			padding: 0 1.25rem;
		}

		.in-depth-item-container .in-depth-item {
			margin: 2.6rem 0 6rem 0;
			gap: 3rem;
		}

		.in-depth-title .svg-icon {
			height: 4.5rem;
		}

		.in-depth-item {
			margin-top: 7.125rem;
			gap: 3.75rem;
		}

		.exit-in-depth {
			right: 1.25rem;
			top: calc(var(--menu-size) + 1.8rem);
		}

		.exit-in-depth .svg-icon {
			width: var(--s2);
			height: var(--s2);
		}

		.in-depth-text-content {
			line-height: 1.75rem;
		}

		.in-depth-title-content {
			font-size: 1.375rem;
		}

		.in-depth-subtitle-content {
			font-size: 1rem;
		}
	}


</style>
